/**
 * Timings for story “resources” phase entrance (Framer Motion, ease-in-out).
 * Hero leads; title overlaps before hero ends; then chained blocks.
 */
export const storyResourcesEntrance = {
  ease: [0.42, 0, 0.58, 1] as const,
  offsetY: 20,
  heroDuration: 0.5,
  blockDuration: 0.42,
  categoryDelay: 0.18,
  titleDelay: 0.28,
  descriptionDelay: 0.4,
  resourcesDelay: 0.52,
  /** Tras PageTransition idle: el botón cerrar entra un poco después del hero. */
  closeButtonDelay: 0.26,
  /** Karaoke (transcripción) + play en barra inferior: misma curva y duración. */
  karaokePlayEntranceDuration: 0.48,
  karaokePlayEntranceButtonY: 22,
  /** Tras el play (misma ventana de entrada): el botón Empezar anima con este retraso. */
  startActivitiesEntranceDelayAfterPlay: 0.4,
} as const;

export function resourcesBlockTransition(reducedMotion: boolean, duration: number, delay: number) {
  if (reducedMotion) {
    return { duration: 0, delay: 0 };
  }
  return {
    duration,
    delay,
    ease: storyResourcesEntrance.ease,
  };
}

/** No animar hasta que PageTransition haya terminado (allowContentEntrance). */
export function entranceAwareBlockTransition(
  pageReady: boolean,
  reducedMotion: boolean,
  duration: number,
  delay: number
) {
  if (!pageReady || reducedMotion) {
    return { duration: 0, delay: 0 };
  }
  return {
    duration,
    delay,
    ease: storyResourcesEntrance.ease,
  };
}

export function entranceAwareHeroTransition(pageReady: boolean, reducedMotion: boolean) {
  if (!pageReady || reducedMotion) {
    return { duration: 0 };
  }
  return {
    duration: storyResourcesEntrance.heroDuration,
    ease: storyResourcesEntrance.ease,
  };
}

export function entranceAwareCloseButtonTransition(pageReady: boolean, reducedMotion: boolean) {
  if (!pageReady || reducedMotion) {
    return { duration: 0, delay: 0 };
  }
  return {
    duration: storyResourcesEntrance.heroDuration,
    delay: storyResourcesEntrance.closeButtonDelay,
    ease: storyResourcesEntrance.ease,
  };
}

/**
 * Entrada barra inferior / karaoke (tras carga de transcripción y pageReady).
 * @param delayAfterPlay — segundos extra antes de la animación (p. ej. botón Empezar tras el play).
 */
export function karaokePlayEntranceTransition(
  reducedMotion: boolean,
  pageReady: boolean,
  contentReady: boolean,
  delayAfterPlay = 0
) {
  if (reducedMotion || !pageReady || !contentReady) {
    return { duration: 0, delay: 0 };
  }
  return {
    duration: storyResourcesEntrance.karaokePlayEntranceDuration,
    delay: delayAfterPlay,
    ease: storyResourcesEntrance.ease,
  };
}
